module.exports = __webpack_public_path__ + "img/icon-firefoxbrowser.9dfdd41e.svg";